module.exports = __webpack_public_path__ + "assets/img/service_img.d9878a61.png";